export const globetrottersAudioEffects: Map<string, string> = new Map<string, string>([
  ['adventure_globetrotters_ambiance', 'fx/adventure_globetrotters_ambiance.mp3'],
  ['adventure_globetrotters_aliens', 'fx/adventure_globetrotters_aliens.mp3'],
  ['adventure_globetrotters_aliens_ambiance', 'fx/adventure_globetrotters_aliens_ambiance.mp3'],
  ['adventure_globetrotters_computers', 'fx/adventure_globetrotters_computers.mp3'],
  ['adventure_globetrotters_boat', 'fx/adventure_globetrotters_boat.mp3'],
  ['adventure_globetrotters_seagulls', 'fx/adventure_globetrotters_seagulls.mp3'],
  ['adventure_globetrotters_storm', 'fx/adventure_globetrotters_storm.mp3'],
  ['adventure_globetrotters_tiger', 'fx/adventure_globetrotters_tiger.mp3'],
  ['adventure_globetrotters_jungle', 'fx/adventure_globetrotters_jungle.mp3'],
  ['adventure_globetrotters_birds', 'fx/adventure_globetrotters_birds.mp3'],
  ['adventure_globetrotters_wind', 'fx/adventure_globetrotters_wind.mp3'],
  ['adventure_globetrotters_snake_rattle', 'fx/adventure_globetrotters_snake_rattle.mp3'],
  ['adventure_globetrotters_snake_hiss', 'fx/adventure_globetrotters_snake_hiss.mp3'],
  ['adventure_globetrotters_flies', 'fx/adventure_globetrotters_flies.mp3'],
  ['adventure_globetrotters_under_water', 'fx/adventure_globetrotters_under_water.mp3'],
  ['adventure_globetrotters_sonar', 'fx/adventure_globetrotters_sonar.mp3'],

  ['world_globetrotters_fly', 'fx/world_globetrotters_fly.mp3'],
  ['world_globetrotters_camera', 'fx/world_globetrotters_camera.mp3'],
  ['world_globetrotters_ambiance', 'fx/world_globetrotters_ambiance.mp3'],
  ['world_globetrotters_announcement_1', 'fx/world_globetrotters_announcement_1.mp3'],
  ['world_globetrotters_announcement_2', 'fx/world_globetrotters_announcement_2.mp3'],
  ['world_globetrotters_announcement_3', 'fx/world_globetrotters_announcement_3.mp3'],
  ['world_globetrotters_compass', 'fx/world_globetrotters_compass.mp3'],
  ['adventure_globetrotters_sonar', 'fx/adventure_globetrotters_sonar.mp3'],
  ['world_globetrotters_watch', 'fx/world_globetrotters_watch.mp3'],
  ['world_globetrotters_headphones', 'fx/world_globetrotters_headphones.mp3'],
]);